(function($) {

  $.fn.videoPlayInPlace = function(options) {
    
    var defaults = {
        autoplay: false,
        trackingid: null,
    };
    
    options = $.extend(defaults, options);

    return this.each(function() {

      const $video = $(this);
      const video = $video.get(0);
      const $wrapper = $video.parent();

      // Overlay erzeugen
      const $overlay = $('<div class="video-play-overlay"></div>');
      $wrapper.append($overlay);

      // --- Play via Overlay ---
      $overlay.on('click', function(e) {
          e.stopPropagation();
          video.play();
          $overlay.fadeOut();
      });

      // --- Toggle Play/Pause bei Videoklick ---
      $video.on('click', function() {
          if (video.paused) {
              video.play();
              $overlay.fadeOut();
          } else {
              video.pause();
              $overlay.fadeIn();
          }
      });

      // Overlay anzeigen wenn Video stoppt
      $video.on('pause ended', function() {
          if (video.paused) {
              $overlay.fadeIn();
          }
      });

      // Overlay verstecken wenn Play über andere Wege startet
      $video.on('play', function() {
          $overlay.fadeOut();
          if(options.trackingid != null) {
            pSendGAEvent('pt_video_click', {'pt_video_id': options.trackingid}, 'plugin_videoPlayInPlace.js', 'Video send event gone wrong');
          }
      });
      
      if(options.autoplay) {
        $overlay.hide();
        $video.trigger('click');
      }

    });

  };

})(jQuery);